import type { ImageWidget } from "~/types/widgets"
import Icon from "~/components/ui/Icon"

export interface Product {
    /**
     * @title Imagem
     */
    image: ImageWidget

    /**
     * @title Título
     */
    label: string

    /**
     * @title Descrição
     */
    url: string
}

export interface Props {
    /**
     * @title Título
     */
    title: string

    /**
     * @title Itens
     */
    products: Product[]

    /**
     * @title Imagem de fundo
     */
    backgroundImage?: ImageWidget
}

export default function Products({ title, products, backgroundImage }: Props) {
    if (!products?.length) return null

    return (
        <div
            className='py-12 bg-fixed lg:bg-scroll'
            style={{ backgroundImage: `url(${backgroundImage})` }}
        >
            <div className='max-w-[1810px] mx-auto font-lato grid justify-items-center gap-8 lg:gap-12'>
                <h2 className='text-white text-[38px] text-center font-black resale-lingerie-scale-animation lg:text-[54px]'>
                    {title}
                </h2>

                <ul className='w-full flex flex-wrap justify-center gap-x-8 gap-y-12 lg:flex-nowrap'>
                    {products.map(({ image, label, url }, index) => (
                        <li>
                            <a className='grid justify-items-center gap-2' href={url}>
                                <div className='relative group resale-lingerie-shake-animation'>
                                    <Icon
                                        id='Heart'
                                        className='text-[#8a1538] transition-colors duration-300 group-hover:text-[#f8ea9c]'
                                        width={80}
                                        height={80}
                                    />

                                    <span className='pt-4 text-white text-[40px] font-black absolute top-1/3 -translate-y-1/2 left-1/2 -translate-x-1/2'>
                                        {index + 1}°
                                    </span>
                                </div>

                                <img
                                    className='aspect-square object-contain'
                                    src={image}
                                    alt={label}
                                    width={232}
                                    height={232}
                                    loading='lazy'
                                />

                                <h3 className='text-white text-lg text-center font-bold resale-lingerie-scale-animation'>
                                    {label}
                                </h3>

                                <button
                                    type='button'
                                    className='w-32 h-12 rounded-full bg-white text-[#ff8a3d] text-[18px] text-center font-black uppercase flex justify-center items-center transition-colors duration-300 resale-lingerie-scale-animation hover:bg-black hover:text-white lg:text-[15px]'
                                >
                                    Comprar
                                </button>
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}
